import M from 'materialize-css';
import flatpickr from 'flatpickr';
import ItalianFlatPickr from 'flatpickr/dist/l10n/it.js';

const flatpickr_options = {
    altInput: true,
    altFormat: "D j M Y",
    onReady: readyPickers,
}

function readyPickers( dateObj, dateStr, instance ) {
    // console.log('Ready', dateObj, dateStr, instance);

    let toggler = document.getElementById(instance.input.id+'_toggler');
    let resetter = document.getElementById(instance.input.id+'_reset');

    if (resetter) {
        resetter.addEventListener('click', function() {
            instance.clear();
        });
    }
    if (toggler) {
        toggler.addEventListener('click', function() {
            instance.toggle();
        });
    }
}

/**
 * Init the date and time pickers
 * @param style String
 */
function initPickers(style = 'materialize') {

    let pickers = document.querySelectorAll('.datepicker');

    if (style === 'flatpickr') {
        flatpickr.localize( ItalianFlatPickr.it );
    }

    for (let i=0; i < pickers.length; i++) {

        let inst;

        switch (style) {
            case 'flatpickr':

                // noinspection JSValidateTypes
                inst = flatpickr(pickers[i],flatpickr_options);

                break;
            case 'materialize':
            default:

                let real_input = document.getElementById( pickers[i].getAttribute('real-input') );
                if (!real_input) {
                    console.log('Instantiation error, picker without real_input');
                    continue;
                }

                inst = M.Datepicker.init( pickers[i], {
                    ... datepicker_options,
                    defaultDate: new Date(Date.parse(real_input.value))
                });

                let reset = document.getElementById( real_input.id+'_reset' );
                reset.obj = inst;
                reset.addEventListener('click', resetMaterializeDate);

        }

    }

    let time_pickers = document.querySelectorAll('.timepicker');
    for (let j=0; j < time_pickers.length; j++) {

        let inst;

        switch(style) {
            case 'flatpickr':

                // noinspection JSValidateTypes
                inst = flatpickr(time_pickers[j], {
                    ...flatpickr_options,
                    enableTime: true,
                    dateFormat: "Y-m-d H:i",
                    altFormat: "D j M Y H:i",
                });

                let toggler = document.getElementById(time_pickers[j].id+'_toggler');
                let resetter = document.getElementById(time_pickers[j].id+'_reset');
                resetter.addEventListener('click', function() {
                    inst.clear();
                });
                toggler.addEventListener('click', function() {
                    inst.toggle();
                });

                break;
            case 'materialize':
            default:

                let real_input = document.getElementById( time_pickers[j].getAttribute('real-input') );
                if (!real_input) {
                    console.log('Instantiation error, picker without real_input');
                    continue;
                }
                let time = new Date(Date.parse(real_input.value));
                timepicker_options.defaultTime = time.getHours()+":"+time.getMinutes();
                inst = M.Timepicker.init( time_pickers[j], timepicker_options );
                inst.el.value = timepicker_options.defaultTime;
                delete timepicker_options.defaultTime;

        }

    }
}

const datepicker_options = {
    format: 'd mmmm yyyy',
    parse: _parseMaterializeDate,
    firstDay: 1,
    minDate: new Date(new Date().getFullYear() - 80, 0, 1),
    maxDate: new Date(new Date().getFullYear() + 6, new Date().getMonth(), new Date().getUTCDate() + 1),
    yearRange: 20,
    showClearBtn: false,
    setDefaultDate: true,
    //selectYears: 83,
    //today: "Oggi",
    //close: "Chiudi",
    i18n: {
        months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        weekdays: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        weekdaysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        weekdaysAbbrev: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        clear: "Reset",
        cancel: "Annulla",
        done: "Ok",
        previousMonth: "&#x3C;Prec",
        nextMonth: "Succ&#x3E;",
    },
    onSelect: selectMaterializeDate
};

const timepicker_options = {
    showClearBtn: false,
    defaultTime: '12:00',
    fromNow: 0,             // set default time to * milliseconds from now (using with default = 'now')
    i18n: {
        cancel: 'Annulla',
        clear: 'Reset',
        done: 'Seleziona'
    },
    autoClose: true,       // automatic close timepicker
    twelveHour: false,      // Use AM/PM or 24-hour format

    ampmclickable: true, // make AM PM clickable
    onSelect: selectMaterializeTime //Function for after opening timepicker
};

function selectMaterializeDate() {

    let real_input = document.getElementById( this.el.getAttribute('real-input') );

    if (!real_input) {
        console.log('No real input specified');
        return;
    }

    // TODO understand what to do with +2 UTC that move day at day before at 10pm
    if (this.el.classList.contains('combo')) {
        selectDateCombo(this);
    } else {
        if (this.date === null) {
            real_input.value = '';
        } else {
            real_input.value = (new Date( this.date.getTime() - this.date.getTimezoneOffset() * 60000)).toISOString().slice(0, 19).replace('T', ' ');
        }
    }

}

function selectMaterializeTime(hours, minutes) {
    let real_input = document.getElementById( this.el.getAttribute('real-input') );

    if (!real_input) {
        console.log('No real input specified');
        return;
    }

    // TODO understand what to do with +2 UTC that move day at day before at 10pm
    if (this.el.classList.contains('combo')) {
        selectMaterializeTimeCombo(this);
    } else {
        if (this.time === null) {
            real_input.value = '';
        } else {
            real_input.value = (new Date( this.date.getTime() - this.date.getTimezoneOffset() * 60000)).toISOString().slice(0, 19).replace('T', ' ');
        }
    }
}

function selectDateCombo (object) {
    let real_input = document.getElementById( object.el.getAttribute('real-input') );
    let datetime;

    if (real_input.value !== '')
        datetime = new Date(real_input.value);
    else
        datetime = new Date();

    if (object.date !== null) {
        let date = new Date(object.date);

        datetime.setFullYear(date.getFullYear());
        datetime.setMonth(date.getMonth());
        datetime.setDate(date.getDate());
        datetime.setHours(0);
        datetime.setMinutes(0);
        datetime.setSeconds(0);

        datetime = new Date( datetime.getTime() - datetime.getTimezoneOffset() * 60000);

        real_input.value = datetime.toISOString().slice(0, 19).replace('T', ' ');
    } else {
        real_input.value = '';
        let input_time = document.getElementById(object.el.getAttribute('real-input') + '_time');
        input_time.value = '';
    }
}

function selectMaterializeTimeCombo(object) {

    let real_input = document.getElementById( object.el.getAttribute('real-input') );

    if (real_input.value === '') {
        alert('Devi prima selezionare una data');
        return;
    }

    let datetime = new Date(real_input.value);
    let time = new Date('1994-02-25 ' + object.hours+":"+object.minutes+ ':00');

    datetime.setHours(time.getHours());
    datetime.setMinutes(time.getMinutes());
    datetime.setSeconds(0);

    datetime = new Date( datetime.getTime() - datetime.getTimezoneOffset() * 60000);

    real_input.value = datetime.toISOString().slice(0, 19).replace('T', ' ');
}

function resetMaterializeDate() {

    let real_input = document.getElementById( this.obj.el.getAttribute('real-input') );

    real_input.value = '';

    this.obj._handleClearClick();

    if (this.obj.el.classList.contains('combo')) {
        let time_el = document.getElementById( this.obj.el.getAttribute('real-input')+'_time' );
        time_el.M_Timepicker.clear();
    }
}

function _parseMaterializeDate() {
    let real_input = document.getElementById( this.el.getAttribute('real-input') );
    if (!real_input) {
        alert('Errore setup data: '+this.id);
        return;
    }
    new Date(Date.parse(real_input.value));
}

export default initPickers;
